import { render } from "./Slider.vue?vue&type=template&id=7e51683e&ts=true"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=7e51683e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__